module.exports = __webpack_public_path__ + "media/images/icons/twotone/customer-service-f3d302fb9db825a23a28cf662496c1c1.svg";